<template>
    <div class="row">
        <div class="col-lg-3 col-3 text-center">
                <img width="50" height="50" src="~/assets/include/shipping.svg" alt="">
                <span>Free <br> Shipping</span>

        </div>
        <div class="col-lg-3 col-3 text-center">
                <img width="50" height="50" src="~/assets/include/lifetime.svg" alt="">
                <span>Lifetime Warranty</span>
        </div>
        <div class="col-lg-3 col-3 text-center">
            <img width="50" height="50" src="~/assets/include/certified.svg" alt="">
            <span>Certified Diamonds</span>
        </div>
        <div class="col-lg-3 col-3 text-center">
            <img v-if="$country.is_india" width="50" height="50" src="~/assets/include/returns_india.svg" alt="">
            <img v-else width="50" height="50" src="~/assets/include/returns.svg" alt="">
            <span v-if="$country.is_india">15 Day <br> Returns</span>
            <span v-else>30 Day <br> Returns</span>
        </div>
    </div>
</template>

<script setup>
    const localePath = useLocalePath()
    const {$country} = useNuxtApp()
</script>

<style scoped>
    span{
        display: block;
        color: #606060;
        font-size: 14px;
        margin-top: 8px;
    }
</style>